exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflow-uploader {\n  margin-right: 0 !important;\n}\n.workflow-uploader i {\n  vertical-align: middle;\n}\n.workflow-uploader span {\n  margin-left: 11px;\n}\n", ""]);

// exports
